module.exports = __webpack_public_path__ + "static/media/tienda.5a5b2485.svg";